import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, useWatch } from '@metarouter-private/mr-mui';

import { CONSENT_MODES } from 'api/consent-modes/modes';

import GatedConsentModeSelect from '../consent-mode/GatedConsentModeSelect';
import GatedConsentCategorySelect from '../consent-category/GatedConsentCategorySelect';

export default function GatedConsentFields({ pipelineId, defaultConsentMode, defaultConsentCategoryId }) {
  const { setValue, clearErrors } = useFormContext();
  const modeFieldName = `${pipelineId}.consentMode`;
  const categoryFieldName = `${pipelineId}.consentCategoryId`;

  const resolvedDefaultMode = defaultConsentMode ?? CONSENT_MODES.ace;
  const resolvedDefaultCategoryId = defaultConsentCategoryId ?? '';

  const selectedMode = useWatch({ name: modeFieldName, defaultValue: resolvedDefaultMode });
  const isExternal = selectedMode === CONSENT_MODES.external;

  // Mode change always clears the dependent category field:
  //   - External forbids a category
  //   - ACE requires a fresh pick after a mode change
  const handleModeChange = () => {
    setValue(categoryFieldName, '');
    clearErrors(categoryFieldName);
  };

  return (
    <>
      <GatedConsentModeSelect name={modeFieldName} defaultValue={resolvedDefaultMode} onChange={handleModeChange} />
      <GatedConsentCategorySelect
        name={categoryFieldName}
        defaultValue={resolvedDefaultCategoryId}
        required={!isExternal}
        disabled={isExternal}
      />
    </>
  );
}

GatedConsentFields.propTypes = {
  pipelineId: PropTypes.string.isRequired,
  defaultConsentMode: PropTypes.string,
  defaultConsentCategoryId: PropTypes.string,
};

GatedConsentFields.defaultProps = {
  defaultConsentMode: null,
  defaultConsentCategoryId: null,
};
